export default __webpack_public_path__ + "static/media/ic_wbnb_40.3de6f65d.svg";